<template>
    <div>
        <div class="content_row">
            <div class="catalog-sub-menu nav-item"
                @click="isShowItemCatalog = !isShowItemCatalog"
                tabindex="0"
            >
                <div class="sub_menu_title">
                    <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 10.5V12.5H20V10.5H0ZM0 5.5V7.5H20V5.5H0ZM0 0.5V2.5H20V0.5H0Z" fill="#356EEF"/>
                    </svg>
                    <span>Каталог</span>
                </div>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="catalog-sub-menu nav-item"
                @click="isShowItemBrands = !isShowItemBrands"
                tabindex="0"
            >
                <div class="sub_menu_title">
                    <span>Бренд</span>
                </div>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="search_input_container">
                <div class="search_input_block">
                    <input class="catalog_search_input" v-model="searchvalItem" placeholder="Пошук" />

                    <svg id="close_modal" v-if="searchvalItem" @click="searchvalItem=null" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
            </div>
            <a href="javascript:void(0)" v-if="getItemProductsLoading" class="search_btn">Зачекайте...</a>
            <a href="javascript:void(0)" v-else v-on:click="getItemProducts()" class="search_btn">Пошук</a>
        </div>


        <DataTable
            :value="selectedItemProducts"
            lazy
            class="customTable mt-3"
        >
            <template #header>
                <div class="table-header">
                    <h5 class="p-m-0">
                        Обрано аксесуарів ({{ selectedItemProducts.length }})
                    </h5>
                </div>
            </template>
            <Column field="article" header="Артикул">
                <template #body="slotProps">
                    {{ slotProps.data.article }}
                </template>
            </Column>
            <Column field="name" header="Найменування">
                <template #body="slotProps">
                    {{ slotProps.data.name }}
                </template>
            </Column>
            <Column v-if="type === 'accessories'" field="type_id" header="Тип аксесуару">
                <template #body="slotProps">
                    <Dropdown v-model="slotProps.data.type_id" @change="changeType" filter :options="types" optionLabel="name" optionValue="code" placeholder="Інше" style="width: 100%;" />
                </template>
            </Column>
            <Column v-if="type === 'buy_with_products'" field="is_mirror" header="Дзеркальний зв’язок">
                <template #body="slotProps">
                    <input @change="changeType" type="checkbox" v-model="slotProps.data.is_mirror">
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <a href="#" @click.prevent="deleteProductsItem(slotProps.data)">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                        </svg>
                    </a>
                </template>
            </Column>
        </DataTable>

        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn" @click="saveProducts()">Зберегти</a>
        </div>



        <Dialog v-model:visible="isShowItemCatalog" id="characteristics-table-11" header="Каталог" modal>
            <InputText class="search_input mb-2" placeholder="Пошук за назвою" v-on:keyup="getCatalogItemTree()" v-model="searchItemCategoryName" />
            <Tree v-if="itemCatalog.length" v-model:selectionKeys="selectedItemCatalogs" :value="itemCatalog" selectionMode="checkbox" class="catalog_tree"></Tree>
            <span v-else>Зачекайте..</span>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="searchCatalogItem()">Зберегти</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isShowItemCatalog=false">Відмінити</a>
                </div>
            </template>
        </Dialog>
        <Dialog v-model:visible="isShowItemBrands" id="characteristics-table2" header="Бренди" modal :style="{ width: '500px' }">
            <InputText class="search_input mb-2" placeholder="Пошук за назвою" v-on:keyup="getItemBrandsTree()" v-model="searchItemBrandName" />

            <template v-if="itemBrands.length">
                <div v-for="brand of itemBrands" :key="brand.key" class="flex items-center mb-2">
                    <Checkbox v-model="selectedItemBrands" :inputId="brand.key" name="category" :value="brand.key" />
                    <label :for="brand.key" class="ml-2">{{ brand.label }} ({{ brand.products_count }})</label>
                </div>
            </template>
            <span v-else>Зачекайте..</span>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="isShowItemBrands=false">Зберегти</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isShowItemBrands=false">Відмінити</a>
                </div>
            </template>
        </Dialog>

        <Dialog v-model:visible="searchedItemProductsModal" id="accessory-products-modal" header="Додавання нового аксесуару" :style="{ width: '500px' }" modal :contentStyle="{ height: '900px' }">
            <div class="search_results">
                <template v-if="searchedItemProducts && searchedItemProducts.length">
                    <div v-for="searchedItemProduct of searchedItemProducts" :key="searchedItemProduct.id" class="flex items-center mb-2">
                        <Checkbox v-model="selectedModalItemProducts" name="category" :value="searchedItemProduct" />
                        <label :for="searchedItemProduct.id" class="ml-2">{{ searchedItemProduct.name }}</label>
                    </div>
                </template>
                <p class="cat_title" v-else>Немає результатів</p>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addProductsItem()">Додати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="searchedItemProductsModal=false">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Tree from 'primevue/tree';
import Checkbox from 'primevue/checkbox';
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import Dropdown from 'primevue/dropdown';

export default {
    props: {
        type: {
            type: String,
            default: null
        },
        types: {
            type: Array,
            default: []
        },
        selected: {
            type: Array,
            default: []
        },
    },

    mounted() {
        this.getCatalogItemTree();
        this.getItemBrandsTree();
    },

    components: {
        Dialog,
        InputText,
        Tree,
        Checkbox,
        DataTable,
        Column,
        Dropdown,
    },

    data() {
        return {
            isShowItemCatalog: false,
            isShowItemBrands: false,
            searchvalItem: null,
            getItemProductsLoading: false,
            searchedItemProductsModal: false,

            itemCatalog: [],
            itemBrands: [],

            searchItemCategoryName: null,
            searchItemBrandName: null,

            selectedItemCatalogs: {},
            selectedItemBrands: [],

            selectedItemProducts: _.cloneDeep(this.selected),
            selectedModalItemProducts: [],
        }
    },

    methods: {
        getItemProducts() {
            this.isShowItemCatalog = false
            this.isShowItemBrands = false
            this.getItemProductsLoading = true
            this.selectedModalItemProducts = []
            axios.post(this.route('api.vector.upload-sku-groups-files.search_all_products'), {
                catalog: this.selectedItemCatalogs,
                brands: this.selectedItemBrands,
                searchval: (this.searchvalItem && this.searchvalItem.length > 2) ? this.searchvalItem : null,
                page: 1
            })
            .then((response) => {
                this.searchedItemProducts = response.data.data.data
                this.searchedItemProductsCount = response.data.data.total
                this.searchedItemProductsModal = true
                this.getItemProductsLoading = false
            }).catch((error) => {
                this.getItemProductsLoading = false
                console.log(error);
                window.scroll(0, 0);
            })
        },

        getCatalogItemTree() {
            axios.get(this.route('api.vector.upload-sku-groups-files.catalog_tree'), {params: {name: this.searchItemCategoryName}})
                .then((result) => {
                    this.itemCatalog = result.data.data
                }).catch((error) => {
                    this.uploading = false
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                })
        },

        searchCatalogItem() {
            this.isShowItemCatalog = false
            
            this.selectedItemBrands = []
            this.getItemBrandsTree()
        },

        getItemBrandsTree() {
            axios.post(this.route('api.vector.upload-sku-groups-files.brands_tree'), {
                    name: this.searchItemBrandName,
                    catalog: this.selectedItemCatalogs,
                    brands: this.selectedItemBrands,
                    searchval: (this.searchvalItem && this.searchvalItem.length > 2) ? this.searchvalItem : null,
                })
                .then((result) => {
                    this.itemBrands = result.data.data
                }).catch((error) => {
                    this.uploading = false
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                })
        },

        deleteProductsItem(item) {
            this.selectedItemProducts = this.selectedItemProducts.filter(item1 => item1.id !== item.id);

            this.$emit(this.type, this.selectedItemProducts)
        },

        addProductsItem() {
            this.selectedItemProducts = [...this.selectedItemProducts, ...this.selectedModalItemProducts]

            this.selectedModalItemProducts = []
            this.searchedItemProductsModal = false

            this.$emit(this.type, this.selectedItemProducts)
        },

        saveProducts() {
            this.$emit('saveProducts')
        },

        changeType() {
            this.$emit(this.type, this.selectedItemProducts)
        },
    }
}
</script>

<style scoped>
.content_row {
    display: flex;
    width: 100%;
    gap: 15px;
}
.catalog-sub-menu {
    position: relative;
    min-width: 200px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    justify-content: space-between;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
    cursor: pointer;
}
.sub_menu_title {
    display: flex;
    align-items: center;
}
.sub_menu_title span {
    margin-left: 8px;
}
.search_input_container {
    position: relative;
    width: 100%;
}

.search_input {
    width: 100%;
}

.search_input_container svg {
    position: absolute;
    top: 15px;
    right: 15px;
}

.catalog_search_input {
    padding: 6px 16px;
    padding-right: 40px;
    min-width: 461px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
}

.catalog_search_input:focus {
    outline: none;
}

.search_input_block {
    position: relative;
}

.search_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
}

.catalog_tree {
    width: 100%;
    border: none;
    padding: 0px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    height: 50vh;
    overflow: auto;
}

.confirm_buttons {
    display: flex;
    gap: 20px;
}

.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.p__confirm_button_cancel {
    max-width: 200px;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}

input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
}
</style>
